/** @format */

// 自定义轮播图组件
theme.jelenewMainArticleNew = new (function () {
  this.onSectionLoad = function (container) {
    // 控制内容的 图片显示
    var imagobj = document.querySelectorAll('.jelenew_main_article_content img');
    imagobj.forEach((img, index) => {
      if(window.innerWidth > 768){
        if (index % 2 === 0) { // 奇数索引（从 0 开始）
          img.style.display = 'block';
        }
      }
      if(window.innerWidth < 768){
        if (index % 2 === 1) { // 偶数索引（从 0 开始）
          img.style.display = 'block';
        }
      }
    });





    let cfg = $(container).data("slick");
    if (cfg.arrows) {
      if (cfg.prevArrow) {
        cfg.prevArrow = `<button type="button" class="slick-prev" aria-label="${theme.strings.previous}"><svg class="icon" aria-hidden="true"><use xlink:href="${cfg.prevArrow}"></use></svg></button>`;
      } else {
        cfg.prevArrow = '<button type="button" class="slick-prev" aria-label="' + theme.strings.previous + '">' + theme.icons.chevronLeft + "</button>";
      }
      if (cfg.nextArrow) {
        cfg.nextArrow = `<button type="button" class="slick-next" aria-label="${theme.strings.next}"><svg class="icon" aria-hidden="true"><use xlink:href="${cfg.nextArrow}"></use></svg></button>`;
      } else {
        cfg.nextArrow = '<button type="button" class="slick-next" aria-label="' + theme.strings.next + '">' + theme.icons.chevronRight + "</button>";
      }
    }
    function setArrowPosition() {
      if ($(".slick-arrow", container).length > 0 && $(".slick-current .img-box", container).length > 0) {
        $(".slick-arrow", container).css("top", $(".slick-current .img-box", container)[0].offsetHeight / 2);
      }
    }
    $(".jelenew_main_article_productLsit", container).slick(cfg).init(setArrowPosition);
    $(".jelenew_main_article_productLsit", container).on("afterChange", setArrowPosition);
    if ($(".slick-arrow", container).length > 0 && $(".slick-current .img-box", container).length > 0) {
      window.addEventListener("resize", setArrowPosition);
    }

    //商品js
    var $container = $(container);
    const enable_item_slider = false;
    const slickCfg = {
      lazyLoad: "ondemand",
      arrows: true,
      dots: true,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      touchThreshold: 5,
      swipe:true,
      speed: 0,
      prevArrow: '<button type="button" class="slick-prev" aria-label="' + theme.strings.previous + '">' + theme.icons.chevronLeft + "</button>",
      nextArrow: '<button type="button" class="slick-next" aria-label="' + theme.strings.next + '">' + theme.icons.chevronRight + "</button>",
    };
     // 第一屏加载slider事件
     if (enable_item_slider) {
      $container.find(".jelenew_pro_block_img_list").slick(slickCfg);
    }
    //pc hover 展示第二张图
    // $container.on("mouseenter mouseleave", ".jelenew_pro_block_img", function (e) {
    //   if (window.innerWidth < 768) return false;
    //   if (enable_item_slider) {
    //     // 获取有几张商品图
    //     var slickItem = $(".jelenew_pro_block_img_list.slick-initialized .jelenew_pro_block_img_item", this);
    //     // 只有一张商品图的  不跳转第二张
    //     if (slickItem.length < 2) return false;

    //     var slickDOM = $(".jelenew_pro_block_img_list.slick-initialized", this);
    //     //只有PC端执行
    //     if (e.type === "mouseenter") {
    //       // if (filtered == false) {
    //       // $(slickDOM).slick("slickFilter", ":not(.product-img-one)");
    //       $(slickDOM).slick("slickGoTo", 1);
    //       //   filtered = true;
    //       // }
    //     } else if (e.type === "mouseleave") {
    //       // if (filtered == true) {
    //       $(slickDOM).slick("slickGoTo", 0);
    //       //   $(slickDOM).slick("slickUnfilter");
    //       //   // $(slickDOM).slick("slickGoTo", 0);
    //       //   filtered = false;
    //       // }
    //     }
    //   } else {
    //     const firstItem = $(".jelenew_pro_block_img_list .jelenew_pro_block_img_item", this).eq(0);
    //     const secondItem = $(".jelenew_pro_block_img_list .jelenew_pro_block_img_item", this).eq(1);
    //     if (secondItem.length > 0) {
    //       const img = secondItem.find("img");
    //       img.attr("src", img.data("lazy"));
    //       if (e.type === "mouseenter") {
    //         firstItem.hide();
    //         secondItem.show();
    //       } else if (e.type === "mouseleave") {
    //         firstItem.show();
    //         secondItem.hide();
    //       }
    //     }
    //   }
    // });
    $container.on("mouseenter", ".jelenew_pro_color_item", function () {
      var $this = $(this);
      if ($this.hasClass("jelenew_pro_color_item_active") || window.innerWidth < 768) {
        return;
      }
      let spu_id = $(this).data("spu");
      let skc_id = $(this).data("skc");
      let sku_id = $(this).data("sku");
      $(this).closest(".jelenew_pro_block_wrap_wrap").data("spu", spu_id);
      $(this).closest(".jelenew_pro_block_wrap_wrap").data("skc", skc_id);
      $(this).closest(".jelenew_pro_block_wrap_wrap").data("sku", sku_id);
      $this.parents(".jelenew_pro_color_list").find(".jelenew_pro_color_item_active").removeClass("jelenew_pro_color_item_active");
      $this.addClass("jelenew_pro_color_item_active");
      var newDomStr = $this.parents(".jelenew_pro_block").find(".jelenew_skc_pro_img_list").html();
      //图片dom
      var newDom = $(newDomStr).find(".jelenew_pro_block_img_list[data-handle=" + $this.data("handle") + "]");
      $this.parents(".jelenew_pro_block").find(".jelenew_pro_block_img .jelenew_pro_block_img_list").remove();
      $this.parents(".jelenew_pro_block").find(".jelenew_pro_block_img").append(newDom);
      $this.parents(".jelenew_pro_block").find(".jelenew_pro_color_item_a,.pro_block_title").attr("href", $this.data("pro_url"));

      // 价格dom
      var priceDom = $(newDomStr).find(".jelenew_pro_block_price[data-handle=" + $this.data("handle") + "]");
      $this.parents(".jelenew_pro_block").find(".jelenew_pro_block_con .jelenew_pro_block_price").remove();
      $this.parents(".jelenew_pro_block").find(".jelenew_pro_block_con").append(priceDom);
      //标签dom
      var topRightTagDom = $(newDomStr).find(".top_right_tag[data-handle=" + $this.data("handle") + "]");
      $this.parents(".jelenew_pro_block").find(".top_right_tag").remove();
      $this.parents(".jelenew_pro_block").append(topRightTagDom);
      if (enable_item_slider) { 
        $this
          .parents(".jelenew_pro_block")
          .find(".jelenew_pro_block_img .jelenew_pro_block_img_list")
          .slick(slickCfg);
      }
      var slickItem = $this
        .parents(".jelenew_pro_block")
        .find(".jelenew_pro_block_img .jelenew_pro_block_img_list.slick-initialized .jelenew_pro_block_img_item");
      if($this.parents(".jelenew_pro_block").find(".jelenew_pro_review_link").length>0){
        // 修改评论链接
        $this.parents(".jelenew_pro_block").find(".jelenew_pro_review_link a").attr("href",$this.data("pro_url")+"?md=jelenew-product-review")
      }
      // sensors.track(theme.jelenew_event_name, {
      //   element_name: "色块",
      //   colour: $(this).data("color"),
      //   page_position: window.theme.jelenew_web_page_name || "",
      //   list_type: "博客页面",
      //   list_name: "博客页面",
      //   category_name: location.pathname.split("/").pop(),
      //   product_name: $this.parents(".jelenew_pro_block").find(".pro_block_title").text().trim(),
      //   product_id: $this.parents(".jelenew_pro_block_wrap_wrap").data("product-id"),
      //   spu_id: $(this).closest(".jelenew_pro_block_wrap_wrap").data("spu"),
      //   skc_id: $(this).closest(".jelenew_pro_block_wrap_wrap").data("skc"),
      //   sku_id: $(this).closest(".jelenew_pro_block_wrap_wrap").data("sku"),
      //   original_price:
      //     $this
      //       .parents(".jelenew_pro_block_wrap_wrap")
      //       .find(".jelenew_pro_block_price")
      //       .text()
      //       .trim()
      //       .match(/\d+(,?\.?)\d*(,?\.?)\d*/)[0]
      //       .replace(",", ".") * 1,
      // });
    });

    // $(container).on("click", ".jelenew_product_item_inner", function () {
    //   const $node = $(this).find(".product-exposure");
    //   sensors.track("ClickProductList", {
    //     page_position: window.theme.jelenew_web_page_name || "",
    //     active_name: window.theme.jelenew_active_name || "",
    //     list_type: "博客页面",
    //     list_name: "博客页面",
    //     product_name: $node.data("title"),
    //     product_id: $node.data("product-id"),
    //     spu_id: $node.data("spu"),
    //     skc_id: $node.data("skc"),
    //     sku_id: $node.data("sku"),
    //     original_price: $node.data("price"),
    //   });
    // })
  };
  
})();
theme.Sections.register("jelenew-main-article-new", theme.jelenewMainArticleNew, { deferredLoad: true });
